(function () {
  if (window.__cartTotalsSyncDefined === true) return;
  window.__cartTotalsSyncDefined = true;

  // QA 26.07.26 (fix critico -- filas del carrito se quedaban con datos
  // viejos): cada llamada a /cart.js (la del stepper, la del boton de
  // eliminar, y la que se agrega mas abajo al cargar la pagina) es una
  // peticion independiente. Si el usuario cambia cantidades rapido justo
  // despues de que la pagina carga, la respuesta MAS VIEJA puede llegar
  // DESPUES que la mas nueva (orden de red no garantizado) y pisar el DOM
  // ya actualizado con datos obsoletos -- eso es exactamente lo que se vio:
  // el input de cantidad ya mostraba el valor nuevo, pero el precio/total
  // de la linea seguian con la cantidad anterior. Fix: un contador
  // compartido -- cada quien que vaya a pedir /cart.js primero "reserva"
  // el siguiente numero, y solo se le permite pintar el DOM si nadie mas
  // reservo un numero mayor mientras esperaba la respuesta. Una respuesta
  // vieja que llega tarde simplemente se descarta.
  window.__cartSyncSeq = 0;
  window.__cartSyncBumpSeq = function () {
    window.__cartSyncSeq += 1;
    return window.__cartSyncSeq;
  };
  window.__cartSyncApplyIfCurrent = function (requestId, cart) {
    if (requestId === window.__cartSyncSeq) window.__syncCartTotals(cart);
  };
  // Wrapper de conveniencia: reserva un numero, pide /cart.js, y solo pinta
  // si sigue siendo la peticion mas reciente cuando la respuesta llega.
  window.__fetchAndSyncCartTotals = function () {
    var requestId = window.__cartSyncBumpSeq();
    return window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        window.__cartSyncApplyIfCurrent(requestId, cart);
        return cart;
      });
  };

  var formatMoney = function (cents) {
    if (typeof window.formatMoney === 'function' && window.moneyFormat != null) {
      return window.formatMoney(cents, window.moneyFormat);
    }
    var amount = Math.max(0, Math.round(cents)) / 100;
    try {
      return amount.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2 });
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  };

  /* CRO 19.07.26: config de tiers (mayoreo + generales D2C) inyectada por
     sections/main-cart.liquid como JSON, para poder recalcular el envio
     expres / descuento / total estimado en el cliente cuando cambian las
     cantidades, sin depender de que el HTML inicial ya tuviera el valor
     correcto (se quedaba desactualizado tras cada cambio via AJAX). */
  var getConfig = function () {
    var el = document.getElementById('cart-shipping-config');
    if (el == null) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  };

  /* CRO 24.07.26: se agregan tier4/5/6 -- arriba de tier3.max el envio se
     quedaba "Gratis" sin limite superior, pero la tarifa real de Shopify
     (Configuracion > Envios) SI cobra de nuevo arriba de $6,000 para un
     cliente D2C sin descuento que reduzca su total (300/500/800). Los
     checks de tier6/tier5/tier4 llevan un guard `&& generalCfg.tierN`
     por si el JSON inyectado no trae esas claves (config antiguo en cache
     del navegador), para no romper si falta alguna. */
  var getGeneralShipping = function (generalCfg, subtotalCents) {
    if (generalCfg == null || subtotalCents <= 0) return 0;
    if (subtotalCents < generalCfg.tier1.max) return generalCfg.tier1.shipping;
    if (subtotalCents <= generalCfg.tier2.max) return generalCfg.tier2.shipping;
    if (subtotalCents < generalCfg.tier3.max) return generalCfg.tier3.shipping;
    if (generalCfg.tier6 && subtotalCents >= generalCfg.tier6.min) return generalCfg.tier6.shipping;
    if (generalCfg.tier5 && subtotalCents >= generalCfg.tier5.min) return generalCfg.tier5.shipping;
    if (generalCfg.tier4 && subtotalCents >= generalCfg.tier4.min) return generalCfg.tier4.shipping;
    return 0;
  };

  var getWholesaleTier = function (wsCfg, subtotalCents) {
    if (wsCfg == null) return null;
    if (subtotalCents >= wsCfg.tier3.min) return wsCfg.tier3;
    if (subtotalCents >= wsCfg.tier2.min) return wsCfg.tier2;
    if (subtotalCents >= wsCfg.tier1.min) return wsCfg.tier1;
    return null;
  };

  // QA 26.07.26: ahorro real de un item por suscripcion (selling plan),
  // igual al calculo que ya existe en Liquid (main-cart-item.liquid) --
  // no pasa por total_discount, es compare_at_price vs price del propio
  // selling_plan_allocation del item.
  var getItemSubscriptionSavings = function (item) {
    if (item == null || item.selling_plan_allocation == null) return 0;
    var compare = item.selling_plan_allocation.compare_at_price;
    var price = item.selling_plan_allocation.price;
    if (typeof compare !== 'number' || typeof price !== 'number' || compare <= price) return 0;
    return (compare - price) * item.quantity;
  };

  var setShippingText = function (el, cents) {
    if (el == null) return;
    if (cents <= 0) {
      el.textContent = 'Gratis';
      el.classList.add('cart-shipping-free');
    } else {
      el.textContent = formatMoney(cents);
      el.classList.remove('cart-shipping-free');
    }
  };

  window.__syncCartTotals = function (cart) {
    if (cart == null) return;

    var totalPrice = typeof cart.total_price === 'number' ? cart.total_price : 0;

    var $subtotal = document.querySelector('.cart-subtotal-price');
    if ($subtotal != null) {
      var subtotalText = formatMoney(totalPrice);
      if ($subtotal.textContent.trim() !== subtotalText) $subtotal.textContent = subtotalText;
    }

    // CRO 19.07.26: el aviso de ahorro general (icono + "Ahorras $X" arriba
    // del subtotal, solo clientes D2C) ahora SIEMPRE existe en el DOM
    // (hidden en vez de {% if %} en el Liquid) para poder mostrarlo/
    // ocultarlo al instante segun si cart.total_discount es > 0 despues de
    // cada cambio de cantidad -- antes solo se creaba una vez al cargar la
    // pagina y nunca se volvia a evaluar.
    if (typeof cart.total_discount === 'number') {
      var $savingsRow = document.querySelector('[data-cart-savings-row]');
      if ($savingsRow != null) $savingsRow.hidden = cart.total_discount <= 0;

      var $savingsAmount = document.querySelector('.cart-savings-amount');
      if ($savingsAmount != null) {
        var savingsText = '-' + formatMoney(cart.total_discount);
        if ($savingsAmount.textContent.trim() !== savingsText) $savingsAmount.textContent = savingsText;
      }
    }

    /* CRO 19.07.26: recalcula el envio expres (tiers generales o de
       mayoreo) y, para clientes de mayoreo, el descuento por volumen y el
       total estimado. El boton de "Finalizar Pedido" ahora siempre refleja
       el MISMO monto que se muestra como "Total estimado" (subtotal con
       descuento + envio) -- antes el boton solo mostraba cart.total_price
       (sin envio), lo que no coincidia con el total mostrado arriba.
       Pedido explicito de Alejandro. */
    var checkoutTotal = totalPrice;

    var config = getConfig();
    if (config != null) {
      var itemsSubtotal = typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : (typeof cart.original_total_price === 'number' ? cart.original_total_price : 0);

      if (config.isWholesale) {
        var tier = getWholesaleTier(config.wholesale, itemsSubtotal);
        var pct = tier ? tier.pct : 0;
        // QA 26.07.26: si el subtotal de mayoreo NO llega al tier minimo,
        // no hay descuento (pct=0) y el envio ahora usa las tarifas
        // generales D2C (getGeneralShipping) en vez de quedar fijo en
        // "Gratis" -- pedido explicito de Alejandro. Sin descuento
        // aplicado, itemsSubtotal es exactamente lo que el cliente paga,
        // igual que un D2C en ese mismo monto. Espeja el mismo fallback
        // que ya se agrego en sections/main-cart.liquid.
        var shipping = tier ? tier.shipping : getGeneralShipping(config.general, itemsSubtotal);

        // QA 26.07.26 (fix critico -- bajar cantidad no actualizaba el
        // resumen): "discount" se tomaba antes de cart.total_discount (el
        // valor real que calcula Shopify). Ese valor puede quedar un
        // "tick" atrasado -- igual que el retraso ya documentado arriba
        // para cuando el carrito SUBE de tier (CRO 21.07.26), pero mas
        // notorio cuando BAJA: al reducir cantidades y cruzar por debajo
        // de $8,000, Shopify tarda en "quitar" el descuento automatico, y
        // mientras tanto cart.total_discount / cart.total_price seguian
        // reportando el monto CON descuento, asi que "Descuento por
        // volumen" y el tachado de "Total estimado" se quedaban pegados
        // mostrando el ahorro viejo. Fix: se calcula el descuento de forma
        // determinista a partir del % del tier (que YA es deterministico,
        // basado en itemsSubtotal) -- el mismo principio que ya se usa
        // para el precio por producto (ver CRO 20.07.26, fix v3). Cero
        // dependencia de cart.total_discount / cart.total_price aqui.
        //
        // Nota: esto asume que el UNICO descuento relevante para un
        // cliente de mayoreo es el tier por volumen (igual que ya asume
        // el calculo por producto) -- si en el futuro se activa OTRA
        // promocion automatica que tambien aplique a mayoreo, este total
        // no la reflejaria. Confirmar con Alejandro si ese escenario
        // existe.
        var discount = Math.round(itemsSubtotal * (pct / 100));
        var discountedSubtotal = itemsSubtotal - discount;
        var hasWholesaleDiscount = tier != null;

        var $wsSubtotal = document.querySelector('[data-cart-subtotal]');
        if ($wsSubtotal != null) $wsSubtotal.textContent = formatMoney(itemsSubtotal);

        var $discountRow = document.querySelector('[data-cart-discount-row]');
        if ($discountRow != null) $discountRow.hidden = !hasWholesaleDiscount;
        var $discountPct = document.querySelector('[data-cart-discount-pct]');
        if ($discountPct != null) $discountPct.textContent = String(pct);
        var $discountAmount = document.querySelector('[data-cart-discount-amount]');
        if ($discountAmount != null) $discountAmount.textContent = '-' + formatMoney(discount);

        setShippingText(document.querySelector('[data-cart-shipping]'), shipping);

        var totalEstimate = discountedSubtotal + shipping;
        var totalOriginal = itemsSubtotal + shipping;
        var $totalEstimate = document.querySelector('[data-cart-total-estimate]');
        if ($totalEstimate != null) $totalEstimate.textContent = formatMoney(totalEstimate);
        var $totalOriginal = document.querySelector('[data-cart-total-original]');
        if ($totalOriginal != null) {
          $totalOriginal.hidden = !hasWholesaleDiscount;
          $totalOriginal.textContent = formatMoney(totalOriginal);
        }

        checkoutTotal = totalEstimate;
      } else {
        var shippingGeneral = getGeneralShipping(config.general, totalPrice);
        setShippingText(document.querySelector('[data-cart-shipping]'), shippingGeneral);

        // QA 26.07.26 (v2): la caja de resumen D2C ahora comparte la misma
        // estructura y data-* hooks que la de mayoreo (ver
        // sections/main-cart.liquid) -- se llenan aqui con los valores
        // reales de D2C (cart.total_discount nativo de Shopify, NUNCA un
        // % de tier de mayoreo). itemsSubtotal ya esta declarado arriba
        // (cart.items_subtotal_price, subtotal SIN descuento).
        var d2cDiscount = typeof cart.total_discount === 'number' ? cart.total_discount : 0;
        var hasD2CDiscount = d2cDiscount > 0;

        var $d2cSubtotal = document.querySelector('[data-cart-subtotal]');
        if ($d2cSubtotal != null) $d2cSubtotal.textContent = formatMoney(itemsSubtotal);

        var $d2cDiscountRow = document.querySelector('[data-cart-discount-row]');
        if ($d2cDiscountRow != null) $d2cDiscountRow.hidden = !hasD2CDiscount;
        var $d2cDiscountAmount = document.querySelector('[data-cart-discount-amount]');
        if ($d2cDiscountAmount != null) $d2cDiscountAmount.textContent = '-' + formatMoney(d2cDiscount);

        var d2cTotalEstimate = totalPrice + shippingGeneral;
        var d2cTotalOriginal = itemsSubtotal + shippingGeneral;
        var $d2cTotalEstimate = document.querySelector('[data-cart-total-estimate]');
        if ($d2cTotalEstimate != null) $d2cTotalEstimate.textContent = formatMoney(d2cTotalEstimate);
        var $d2cTotalOriginal = document.querySelector('[data-cart-total-original]');
        if ($d2cTotalOriginal != null) {
          $d2cTotalOriginal.hidden = !hasD2CDiscount;
          $d2cTotalOriginal.textContent = formatMoney(d2cTotalOriginal);
        }

        checkoutTotal = d2cTotalEstimate;
      }
    }

    var $checkoutPrice = document.querySelector('[data-cart-checkout-price]');
    if ($checkoutPrice != null) {
      var checkoutText = '\u00a0- ' + formatMoney(checkoutTotal);
      if ($checkoutPrice.textContent !== checkoutText) $checkoutPrice.textContent = checkoutText;
    }

    // CRO 19.07.26 (fix v2): la tienda tiene OTRAS promociones automaticas
    // activas por cantidad de producto (ej. "Lleva 3 y obten 15% OFF"),
    // independientes del descuento de mayoreo por volumen. Esas promos
    // pueden dejar item.total_discount > 0 en una linea aunque el carrito
    // NO haya llegado al tier de mayoreo -- eso hacia que la etiqueta
    // "Ahorras" apareciera con montos que no corresponden al mayoreo.
    // Pedido explicito de Alejandro: para MAYOREO la etiqueta por producto
    // SOLO debe depender de si el carrito ya califica para un tier (no de
    // si hay CUALQUIER descuento activo en la linea). Este gate cart-wide
    // (cartHasDiscount) es SOLO para mayoreo -- ver fix QA 26.07.26 abajo,
    // que separa el criterio para D2C.
    var cartHasDiscount;
    if (config != null && config.isWholesale) {
      var itemsSubtotalForGate = typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : (typeof cart.original_total_price === 'number' ? cart.original_total_price : 0);
      cartHasDiscount = getWholesaleTier(config.wholesale, itemsSubtotalForGate) != null;
    } else {
      cartHasDiscount = typeof cart.total_discount === 'number' && cart.total_discount > 0;
    }

    // CRO 20.07.26 (fix v3): en vez de confiar en item.total_discount
    // (que puede llegar inflado/inconsistente via AJAX cuando hay varias
    // promociones automaticas activas al mismo tiempo -- confirmado, ver
    // sesion anterior), el ahorro por producto ahora se calcula IGUAL que
    // en Quick Order Mayoristas: de forma determinista, a partir del
    // precio original del producto (item.original_price, que Shopify
    // siempre reporta consistente) y el % del tier de mayoreo que YA
    // conocemos (el mismo que se usa en "Descuento por volumen"). Cero
    // dependencia del calculo de reparto de descuentos de Shopify.
    var wholesaleTierPct = 0;
    if (config != null && config.isWholesale) {
      var tierForItems = getWholesaleTier(
        config.wholesale,
        typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : 0
      );
      wholesaleTierPct = tierForItems ? tierForItems.pct : 0;
    }

    var isWholesaleCart = config != null && config.isWholesale;

    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        var $input = document.querySelector('.cart-item [data-id="' + item.variant_id + '"]');
        var $row = $input != null ? $input.closest('.cart-item') : null;
        if ($row == null) return;

        // QA 26.07.26 (fix critico D2C): antes esta linea usaba
        // cartHasDiscount (una bandera de TODO el carrito) para TODOS los
        // productos, tambien en D2C -- eso hacia que, si un solo producto
        // del carrito tenia descuento, la etiqueta "Ahorras" y el tachado
        // aparecieran en TODAS las filas por igual (con $0.00 en las que
        // no aplicaba), en vez de mostrarse solo en el producto que
        // realmente tiene descuento. Replica exactamente el mismo criterio
        // que ya existe en Liquid (snippets/main-cart-item.liquid,
        // item_shows_discount): en D2C se evalua por producto
        // (item.total_discount > 0 o ahorro de suscripcion), NO con la
        // bandera de todo el carrito. Mayoreo NO se toca -- sigue usando
        // cartHasDiscount a proposito (pedido explicito de Alejandro).
        var hasDiscount;
        if (isWholesaleCart) {
          hasDiscount = cartHasDiscount;
        } else {
          var itemSubSavings = getItemSubscriptionSavings(item);
          hasDiscount = (typeof item.total_discount === 'number' && item.total_discount > 0) || itemSubSavings > 0;
        }

        var unitOriginal = null;
        var unitDiscounted = null;
        var lineOriginal = null;
        var lineDiscounted = null;

        if (hasDiscount && isWholesaleCart) {
          // Wholesale: calculo propio, determinista, basado en el precio
          // original del producto + el % del tier -- no en total_discount.
          unitOriginal = typeof item.original_price === 'number' ? item.original_price : item.price;
          lineOriginal = unitOriginal * item.quantity;
          lineDiscounted = Math.round(lineOriginal * (1 - wholesaleTierPct / 100));
          unitDiscounted = Math.round(unitOriginal * (1 - wholesaleTierPct / 100));
        } else if (hasDiscount) {
          // D2C: sin cambios, sigue usando total_discount tal cual (mas el
          // ahorro de suscripcion del propio item, si aplica).
          var itemSubSavingsForPrice = getItemSubscriptionSavings(item);
          if (item.quantity > 0 && typeof item.line_price === 'number' && typeof item.total_discount === 'number') {
            lineOriginal = item.line_price + item.total_discount + itemSubSavingsForPrice;
            unitOriginal = Math.round(lineOriginal / item.quantity);
            lineDiscounted = item.line_price;
            unitDiscounted = item.price;
          }
        }

        var displayUnitPrice = hasDiscount && unitDiscounted != null ? unitDiscounted : item.price;
        var displayLinePrice = hasDiscount && lineDiscounted != null ? lineDiscounted : item.line_price;
        var discountAmount = hasDiscount && lineOriginal != null && lineDiscounted != null ? lineOriginal - lineDiscounted : 0;

        var $lineTotal = $row.querySelector('.cart-item-line-total-amount');
        if ($lineTotal != null && typeof displayLinePrice === 'number') {
          var lineTotalText = formatMoney(displayLinePrice);
          if ($lineTotal.textContent.trim() !== lineTotalText) $lineTotal.textContent = lineTotalText;
        }

        /* CRO 19.07.26: todos estos indicadores de descuento (precio
           tachado, "Ahorras $X", total de linea original) ahora SIEMPRE
           existen en el DOM (hidden en vez de {% if %} en el Liquid) para
           poder mostrarlos/ocultarlos al instante -- antes solo se creaban
           si el item ya tenia descuento en el primer render, asi que un
           producto que recien cruzaba un tier de descuento (o dejaba de
           calificar tras quitar productos) se quedaba desactualizado hasta
           recargar la pagina. */
        $row.querySelectorAll('[data-cart-item-old-price]').forEach(function (el) {
          el.hidden = !hasDiscount;
          if (unitOriginal != null) el.textContent = formatMoney(unitOriginal);
        });
        $row.querySelectorAll('[data-cart-item-unit-price]').forEach(function (el) {
          if (typeof displayUnitPrice === 'number') el.textContent = formatMoney(displayUnitPrice);
        });

        $row.querySelectorAll('[data-cart-item-savings], [data-cart-item-savings-total]').forEach(function (el) {
          el.hidden = !hasDiscount;
        });
        $row.querySelectorAll('[data-cart-item-savings-amount]').forEach(function (el) {
          if (hasDiscount) el.textContent = 'Ahorras ' + formatMoney(discountAmount);
        });

        $row.querySelectorAll('[data-cart-item-line-total-original], [data-cart-item-line-old-price]').forEach(function (el) {
          el.hidden = !hasDiscount;
          if (lineOriginal != null) el.textContent = formatMoney(lineOriginal);
        });
        $row.querySelectorAll('[data-cart-item-line-price]').forEach(function (el) {
          if (typeof displayLinePrice === 'number') el.textContent = formatMoney(displayLinePrice);
        });
      });
    }

    // CRO 20.07.26: si una linea llego a cantidad 0 (removida via el
    // stepper), cart.items ya no la incluye -- hay que quitar su fila del
    // DOM manualmente, porque el bucle de arriba solo actualiza filas que
    // siguen existiendo en la respuesta.
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('.js-cart-item-input');
      if (input == null) return;
      var variantId = input.getAttribute('data-id');
      var stillInCart = Array.isArray(cart.items) && cart.items.some(function (item) {
        return String(item.variant_id) === String(variantId);
      });
      if (!stillInCart) row.remove();
    });

    if (cart.item_count === 0) {
      window.location.reload();
    }
  };

  // QA 26.07.26: fix para el caso reportado por Alejandro -- un cliente de
  // mayoreo entra a /cart (carga completa, no AJAX) y el resumen NO
  // muestra el descuento automatico por volumen aunque su subtotal ya
  // califica, pero al ir a Finalizar Pedido el checkout SI lo aplica.
  // Causa: los descuentos automaticos de Shopify se recalculan cuando el
  // carrito se MODIFICA (agregar/actualizar/eliminar) o en checkout, no
  // necesariamente en cada carga/vista de /cart -- si el cliente inicio
  // sesion como mayorista DESPUES de que el carrito ya tenia productos (o
  // el descuento se activo sin una mutacion posterior del carrito), el
  // HTML servido por Liquid puede quedar desactualizado aunque el
  // checkout si recalcule fresco. Igual que el fix ya existente para
  // cambios de cantidad (fetchFreshCart en js-cart-quantity-stepper.js),
  // se hace UNA sola llamada silenciosa a /cart.js al cargar la pagina y
  // se usa ese resultado para refrescar los totales con __syncCartTotals
  // -- si todo ya estaba correcto, es un no-op; si estaba stale, se
  // autocorrige sin necesitar recargar la pagina manualmente.
  var runInitialSync = function () {
    if (document.getElementById('cart-shipping-config') == null) return;
    window.__fetchAndSyncCartTotals().catch(function () {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialSync);
  } else {
    runInitialSync();
  }
})();
